<template>
  <div class="box-wrapper">
    <div>
      <template v-if="$route.query.request">
        <div class="notification notification-notice" style="padding:10px 15px 35px 15px;">
          <div class="notification-inner">
            <span class="notification-icon"></span>
            <span class="notification-text">{{$t('homeRequestSuccessfulMessage')}}</span>
            <a @click="hideSuccessMessage" class="notification-dismiss" data-notification-dismiss></a>
          </div>
        </div>
      </template>
    </div>
    <component v-bind:is="headerComponent"></component>
    <div>
      <ul class="row-container row-container--l-lsweepshc category-boxes cf">
        <li @click="trackPageClick('using_sitename')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'using-site'}">
            <h3 class="title">{{categories[getCategoryIdByName('using-site')].title}}</h3>
            <svg
                width="48"
                height="52"
                viewBox="0 0 48 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="icon"
            >
              <path d="M42.2548 0.75H5.40575C2.48415 0.75 0.141602 3.075 0.141602 5.91667V42.0833C0.141602 44.925 2.48415 47.25 5.40575 47.25H42.2548C45.1501 47.25 47.519 44.925 47.519 42.0833V5.91667C47.519 3.075 45.1764 0.75 42.2548 0.75ZM42.2548 42.0833H5.40575V11.0833H42.2548V42.0833ZM36.9907 24H10.6699V18.8333H36.9907V24ZM26.4624 34.3333H10.6699V29.1667H26.4624V34.3333Z" fill="#1BBA48"/>
            </svg>
            <p class="text" v-html="categories[getCategoryIdByName('using-site')].body"></p>
          </router-link>
        </li>

        <li @click="trackPageClick('billing_support')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'billing-support'}">
            <h3 class="title">{{categories[getCategoryIdByName('billing-support')].title}}</h3>
            <svg
                width="28"
                height="52"
                viewBox="0 0 28 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="icon"
            >
              <path d="M15.3037 21.1583C9.32885 19.6342 7.40743 18.0583 7.40743 15.6042C7.40743 12.7883 10.0658 10.825 14.514 10.825C19.1991 10.825 20.9363 13.0208 21.0942 16.25H26.9111C26.7269 11.8067 23.9632 7.725 18.4621 6.4075V0.75H10.5659V6.33C5.45969 7.415 1.35366 10.67 1.35366 15.6558C1.35366 21.6233 6.38092 24.5942 13.7244 26.325C20.3046 27.875 21.6206 30.1483 21.6206 32.5508C21.6206 34.3333 20.3309 37.175 14.514 37.175C9.09196 37.175 6.95998 34.7983 6.67045 31.75H0.879883C1.19573 37.4075 5.51234 40.585 10.5659 41.6442V47.25H18.4621V41.6958C23.5947 40.74 27.6744 37.8208 27.6744 32.525C27.6744 25.1883 21.2785 22.6825 15.3037 21.1583Z" fill="#1BBA48"/>
            </svg>

            <p class="text" v-html="categories[getCategoryIdByName('billing-support')].body"></p>
          </router-link>
        </li>

        <li @click="trackPageClick('account_support')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'account-support'}">
            <h3 class="title">{{categories[getCategoryIdByName('account-support')].title}}</h3>
            <svg
                width="54"
                height="52"
                viewBox="0 0 54 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="icon"
            >
              <path d="M38.6746 19C42.3069 19 45.2285 16.1067 45.2285 12.5417C45.2285 8.97669 42.3069 6.08335 38.6746 6.08335C35.0424 6.08335 32.0944 8.97669 32.0944 12.5417C32.0944 16.1067 35.0424 19 38.6746 19ZM18.934 16.4167C23.3033 16.4167 26.804 12.955 26.804 8.66669C26.804 4.37835 23.3033 0.916687 18.934 0.916687C14.5648 0.916687 11.0378 4.37835 11.0378 8.66669C11.0378 12.955 14.5648 16.4167 18.934 16.4167ZM38.6746 24.1667C33.8579 24.1667 24.1982 26.5434 24.1982 31.2709V37.0834H53.151V31.2709C53.151 26.5434 43.4913 24.1667 38.6746 24.1667ZM18.934 21.5834C12.8013 21.5834 0.509521 24.6059 0.509521 30.625V37.0834H18.934V31.2709C18.934 29.075 19.8026 25.2259 25.1721 22.3067C22.8822 21.8417 20.6712 21.5834 18.934 21.5834Z" fill="#1BBA48"/>
            </svg>

            <p class="text" v-html="categories[getCategoryIdByName('account-support')].body"></p>
          </router-link>
        </li>

        <li @click="trackPageClick('competition_details')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'competition-details'}">
            <h3 class="title">{{categories[getCategoryIdByName('competition-details')].title}}</h3>
            <svg width="54" height="52" viewBox="0 0 54 52" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon">
              <path d="M26.8037 0.166687C12.2747 0.166687 0.509277 11.74 0.509277 26C0.509277 40.26 12.2747 51.8334 26.8037 51.8334C41.3591 51.8334 53.1508 40.26 53.1508 26C53.1508 11.74 41.3591 0.166687 26.8037 0.166687ZM37.9637 41.5L26.83 34.9125L15.6964 41.5L18.6443 29.0742L8.82664 20.73L21.7764 19.645L26.83 7.91669L31.8836 19.6192L44.8334 20.7042L35.0158 29.0484L37.9637 41.5Z" fill="#1BBA48"/>
            </svg>

            <p class="text" v-html="categories[getCategoryIdByName('competition-details')].body"></p>
          </router-link>
        </li>

        <li @click="trackPageClick('faq')" class="category-boxes__item">
          <router-link class="category-boxes__item__link" :to="{name: 'faq'}">
            <h3 class="title">{{categories[getCategoryIdByName('faq')].title}}</h3>
            <svg width="54" height="52" viewBox="0 0 54 52" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon">
              <path d="M50.5187 10.5H45.2546V33.75H11.0376V38.9167C11.0376 40.3375 12.222 41.5 13.6697 41.5H42.6225L53.1508 51.8334V13.0834C53.1508 11.6625 51.9664 10.5 50.5187 10.5ZM39.9904 26V2.75002C39.9904 1.32919 38.806 0.166687 37.3583 0.166687H3.14135C1.69371 0.166687 0.509277 1.32919 0.509277 2.75002V38.9167L11.0376 28.5834H37.3583C38.806 28.5834 39.9904 27.4209 39.9904 26Z" fill="#1BBA48"/>
            </svg>

            <p class="text" v-html="categories[getCategoryIdByName('faq')].body"></p>
          </router-link>
        </li>

      </ul>
    </div>
    <component v-bind:is="faqComponent"></component>
    <component v-bind:is="footerComponent"></component>
  </div>
</template>

<script>
import { getComponent, getCategoryPageName, getCategoryIdByName, trackPageView, trackPageClick } from '@/utils/common';

export default {
  name: 'home',
  metaInfo() {
    return {
      titleTemplate: `%s`
    };
  },
  created() {
    if (this.$route.query.request) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
    trackPageView('home');
  },
  computed: {
    categories() {
      return this.$store.state.categories;
    },
    articles() {
      return this.$store.state.articles;
    },
    // Getting Component Dynamically & Asynchronously
    headerComponent() {
      return getComponent(this.$store.getters.flowObject, 'header');
    },
    footerComponent() {
      return getComponent(this.$store.getters.flowObject, 'footer');
    },
    faqComponent() {
      return getComponent(this.$store.getters.flowObject, 'home_faq');
    }
  },
  methods: {
    getCategoryPageName(catId) {
      return getCategoryPageName(catId, this.$store.getters.flowObject.pages);
    },
    getCategoryIdByName(catName) {
      return getCategoryIdByName(catName);
    },
    hideSuccessMessage() {
      this.$router.push({ path: window.location.pathname });
    },
    trackPageClick(clickName) {
      return trackPageClick(clickName);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/styles/variables.scss';

@import '@/styles/lsweepshc-design.scss';


.category-boxes {
  list-style-type: none;
  padding: 0;
  font-size: 0.9rem;
  font-weight: 300;
  padding: 0 5%;

  @media (min-width: 600px) {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;

    color: #2b2b2b;
  }
  @media (min-width: 960px) {
    font-size: 1rem;
  }
  @media (min-width: 1160px) {
    padding: 0;
    width: 90%;
  }
}
.category-boxes__item {
  padding: 0 1rem;
}
.category-boxes__item__link {
  text-align: center;
  border: 1px solid #888;
  text-decoration: none;
  margin: 0 auto;
  line-height: 1.5rem;
  border-radius: 3px;
  padding: 1rem;
  display: block;
  height: 100%;
  max-width: 28.3rem;

  .title {
    font-family: 'Montserrat';
    font-style: italic;
    font-weight: 800 !important;
    font-size: 16px;
    line-height: 20px;
    color: #2b2b2b;
    transition: 0.2s linear all;
    margin: 0 0 0.3rem 0;
  }

  .icon {
    width: 27px;
    polygon,
    path {
      transition: 0.2s linear all;
      fill: $theme-highlight;
    }
  }

  .text {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
    color: #2b2b2b;
  }

  &:hover {
    background-color: $theme-highlight;
    color: #fff;

    .title,
    .text {
      color: #fff;
    }
    .icon {
      polygon,
      path {
        fill: #fff;
      }
    }
  }
}

@media (min-width: 641px) {
  .category-boxes__item__link {
    padding: 1.5em;

    .title {
      margin-top: 0.6rem;
      margin-bottom: 1rem;
      font-size: 1.1rem;
    }
    .icon {
      width: 40px;
    }
    .text {
      margin-top: 1.1rem;
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 19px;
    }
  }
}
.category-boxes__item {
  width: 100%;
}
@media (min-width: 40em) {
  .category-boxes__item {
    width: calc(50% - 2px);
  }
}
@media (min-width: 52em) {
  .category-boxes__item {
    width: calc(33.3% - 2px);
    margin-bottom: 0;
  }
}
@media (min-width: 73em) {
  .category-boxes__item {
    width: calc(20% - 2px);
  }
}
.notification-inner {
  position: relative;
  margin: 0 auto;
  padding: 0 20px;
  max-width: 980px;
}
.notification {
  border: 1px solid;
  display: table;
  font-family: sans-serif;
  font-size: 12px;
  padding: 10px 15px 15px 15px !important;
  transition: height 0.2s;
  width: 100%;
  color: #555;
  text-align: center;
}
.notification-notice {
  background: #dbf3ff;
}

.notification-text {
  padding-left: 15px;
  padding-right: 5px;
  width: 100%;
  display: block;
  text-align: left;
}

.notification-dismiss,
.notification-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-decoration: none;
}

.notification-dismiss {
  cursor: pointer;
  right: 0;
}

.notification-icon {
  left: 0;
}

.notification-dismiss::before {
  display: inline-block;
  line-height: 20px;
  text-align: center;
  width: 20px;
}

.notification-dismiss::before {
  color: #000;
  color: initial;
  content: '\2715';
  font-family: sans-serif;
  font-size: 16px;
  opacity: 0.6;
  transition: opacity 100ms ease;
  text-decoration: none !important;
}
.notification-icon::before {
  content: '\2713';
  display: inline-block;
  line-height: 20px;
  text-align: center;
  width: 20px;
  border: 1px solid #b5e0f5;
  border-radius: 50%;
  font-family: 'entypo';
}
</style>
